import { useState } from "react";
import Items from "./Items";
import Inventory from "./Inventory";

export default function StockItems() {
  const [tab, setTab] = useState("Items");
  return <div data-testid="stock-items-page" className="space-y-5">
    <div><h1 className="text-3xl font-heading font-bold">Stock & Items</h1><p className="text-sm text-slate-500">Medicines, live batches and expiry alerts in one place.</p></div>
    <div role="tablist" className="flex gap-2 border-b border-slate-200">{["Items", "Stock & Batches", "Expiry Alerts"].map(v => <button key={v} role="tab" aria-selected={tab === v} className={`px-4 py-2 text-sm ${tab === v ? "border-b-2 border-amber-500 font-bold" : "text-slate-500"}`} onClick={() => setTab(v)}>{v}</button>)}</div>
    {tab === "Items" ? <Items /> : <Inventory key={tab} embedded initialStatus={tab === "Expiry Alerts" ? "near_expiry" : "instock"} />}
  </div>;
}
